import apiActions from '../Actions/apiActions';
import commonActions from '../Actions/commonActions';
import { hasSessionExpired, isNetworkError, type ApiError } from './httpClient';
import type { AppDispatch } from '../Store/types';

export const reportSearchError = async (dispatch: AppDispatch, error: unknown): Promise<void> => {
    if (isNetworkError(error) && !(await hasSessionExpired())) {
        dispatch(commonActions.showError('The search could not reach the server. Check your connection and try again.', 'Search failed'));
        return;
    }

    dispatch(apiActions.apiErrorOccurred(error as ApiError));
};
